export default __webpack_public_path__ + "static/media/rebalancing.de1e697e.svg";